import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiSoestSchipholPage() {
  return (
    <CityAirportTemplate
      city="Soest"
      airport="schiphol"
      airportName="Schiphol Airport"
      price={60.00}
      distance="50 km"
      duration="40-45 minuten"
    />
  );
}
